// extracted by mini-css-extract-plugin
export var leftAlign = "_v-2";
export var popper = "_v-0";
export var subtitle = "_v-1";